import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const Notes = ({ form, loadForm }) => {
  const [notes, setNotes] = useState(form.notes);

  const handleChange = e => {
    setNotes(e.target.value);
  };

  const handleSave = () => {
    Api.saveForm(form.id, { notes }).then(() => {
      loadForm();
    });
  };

  return (
    <div>
      <Input height={300} onChange={handleChange} type='textarea' value={notes} />
      <Button inline={true} onClick={handleSave} style={{ marginTop: 30 }}>
        Save Changes
      </Button>
    </div>
  );
};

Notes.propTypes = {
  form: PropTypes.object,
  loadForm: PropTypes.func
};

export default Notes;
